import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { Observable } from "rxjs";
import { URLConfig } from "../network/urlStore";
import { IToDoResponse } from "../models/IToDoResponse.model";
import axios from "axios";
import { ITeams, ITeamsAllResponse } from "../models/ITeam.model";
import { ITrialBookAllResponse } from "../models/ITrialBook.model";
import NetworkService from "../network/networkService";
import { IDashboardLocationResponse, IDashboardOverviewResponse } from "../models/IDashboardView.model";

export const getToDoDashboard = (
	queryParams?: Array<{
		key: AgTechQueryParam | OdQueryParam;
		value: string[];
	}>
): Observable<IToDoResponse> => {
	let url = URLConfig.getToDoDetailsURL();

	// Add query parameters if provided
	if (queryParams && queryParams.length > 0) {
		for (const param of queryParams) {
			url = helperFunctions.addQueryParam(url, param.key, param.value);
		}
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(response: any) => {
				if (response) {
					console.log("ToDo Dashboard fetched successfully:", response);
					subscriber.next(response);
					subscriber.complete();
				}
			},
			(error: any) => {
				subscriber.error(error);
				console.error("Error fetching ToDo Dashboard:");
			}
		);
	});
};

export const getToDoDashboardNextPage = (
	nextPageURI: string
): Observable<IToDoResponse> => {
	const url = URLConfig.getToDoDetailsNextPageURL(nextPageURI);
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(response: any) => {
				console.log("ToDo Dashboard fetched successfully:", response);
				subscriber.next(response);
				subscriber.complete();
			},
			(error: any) => {
				console.error("Error fetching ToDo Dashboard:");
				subscriber.error(error);
			}
		);
	});

};


export const postCreateToDo = (
	payload: any
): Observable<any> => {
	const url = URLConfig.postCreateToDoURL();
	return new Observable((subscriber) => {
		NetworkService.post(url, payload).then(
			(response: any) => {
				console.log("ToDo created successfully:", response);
				subscriber.next(response);
				subscriber.complete();
			},
			(error: any) => {
				console.error("Error creating ToDo:");
				subscriber.error(error);
			}
		);
	});
}

export const getDashboardStatus = (
	season: string
): Observable<any> => {
	const url = URLConfig.getDashboardStatusURL(season);
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(response: any) => {
				console.log("Dashboard status fetched successfully:", response);
				subscriber.next(response);
				subscriber.complete();
			},
			(error: any) => {
				console.error("Error fetching Dashboard status:", error);
				subscriber.error(error);
			}
		);
	});
};
export const getTeams = (
	queryParams?: Array<{
		key: AgTechQueryParam | OdQueryParam;
		value: string[];
	}>
): Observable<ITeamsAllResponse> => {
	let url = URLConfig.getTeamsMasterDataURL();
	for (let param of queryParams || []) {
		url = helperFunctions.addQueryParam(url, param.key, param.value);
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(
			(res: any) => {
				if (res) {
					const response = res.data as unknown as ITeamsAllResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: any) => {
				subscriber.error(error);
				console.log("Error while fetching crops master data", error);
			}
		);
	});

};

export const getTeamsNextPage = (
	nextPageURI: string
): Observable<ITeamsAllResponse> => {
	let url = URLConfig.getTeamsNextPageURl(nextPageURI);

	return new Observable((subscriber) => {
		axios.get(url).then(
			(res) => {
				if (res) {
					const response = res as unknown as ITeamsAllResponse;
					subscriber.next(response);
				}
				subscriber.complete();
			},
			(error: any) => {
				subscriber.error(error);
				console.log("Error while fetching seasons master data", error);
			}
		);
	});
};
export const getAllTeams = (
	queryParams?: Array<{
		key: AgTechQueryParam | OdQueryParam;
		value: string[];
	}>
): Observable<ITeams[]> => {
	let allTeams: ITeams[] = [];

	return new Observable((subscriber) => {
		const errorHandler = (error: any) => {
			subscriber.error(error);
			console.log("Error while fetching Teams master data", error);
		};

		const responseHandler = (response: ITeamsAllResponse) => {
			allTeams = [...allTeams, ...(response.teams || [])];

			if (response.nextPageUri) {
				getTeamsNextPage(response.nextPageUri).subscribe({
					next: responseHandler,
					error: errorHandler,
					complete: () => {
						console.info("Completed fetching paginated teams");
					},
				});
			} else {
				subscriber.next(allTeams);
				subscriber.complete();
			}
		};
		getTeams(queryParams).subscribe({
			next: responseHandler,
			error: errorHandler,
			complete: () => {
				console.info("Completed fetching all States");
			},
		});
	});
};

export const getTrialBookDetails = (queryParams: any): Observable<any> => {
	let url = URLConfig.getTrialBookDetailsURL();
	if (queryParams && queryParams.length > 0) {
		for (const param of queryParams) {
			url = helperFunctions.addQueryParam(url, param.key, param.value);
		}
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			console.log("Trial Book Details fetched successfully:", response);
			subscriber.next(response as unknown as ITrialBookAllResponse);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Trial Book Details:", {
				url,
				message: error.message,
				status: error.response?.status,
				statusText: error.response?.statusText,
				data: error.response?.data,
				headers: error.response?.headers,
			});
			subscriber.error(error);
		});
	});
};

export const getTrialBookDetailsNextPage = (nextPageURI: string): Observable<any> => {
	return new Observable((subscriber) => {
		const url = URLConfig.getTrialBookDetailsNextPageURL(nextPageURI);
		NetworkService.get(url).then(response => {
			console.log("Trial Book Details fetched successfully:", response);
			subscriber.next(response as unknown as ITrialBookAllResponse);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Trial Book Details:", {
				url,
				message: error.message,
				status: error.response?.status,
				statusText: error.response?.statusText,
				data: error.response?.data,
				headers: error.response?.headers,
			});
			subscriber.error(error);
		});
	});
};

export const getFieldRepDetails = (queryParams: any): Observable<any> => {
	let url = URLConfig.getFieldRepDetailsURL();
	if (queryParams && queryParams.length > 0) {
		for (const param of queryParams) {
			url = helperFunctions.addQueryParam(url, param.key, param.value);
		}
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			console.log("Field Rep Details fetched successfully:", response);
			subscriber.next(response);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Field Rep Details:", {
				url,
				message: error.message,
				status: error.response?.status,
				statusText: error.response?.statusText,
				data: error.response?.data,
				headers: error.response?.headers,
			});
			subscriber.error(error);
		});
	});
};

export const getFieldRepDetailsNextPage = (nextPageURI: string): Observable<any> => {
	return new Observable((subscriber) => {
		const url = URLConfig.getFieldRepDetailsNextPageURL(nextPageURI);
		NetworkService.get(url).then(response => {
			console.log("Field Rep Details fetched successfully:", response);
			subscriber.next(response);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Field Rep Details:", {
				url,
				message: error.message,
				status: error.response?.status,
				statusText: error.response?.statusText,
				data: error.response?.data,
				headers: error.response?.headers,
			});
			subscriber.error(error);
		});
	});
};

export const getTodoFilterSchema = (): Observable<any> => {
	const url = URLConfig.getTodoFilterSchemaURL();
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			console.log("Todo Filter Schema fetched successfully:", response);
			subscriber.next(response);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Todo Filter Schema:", url);
			subscriber.error(error);
		});
	});
}

export const getTrialBookFilterSchema = (): Observable<any> => {
	const url = URLConfig.getTrialBookFilterSchemaURL();
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			console.log("Trial Book Filter Schema fetched successfully:", response);
			subscriber.next(response);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Trial Book Filter Schema:", url);
			subscriber.error(error);
		});
	});
}

export const getFieldRepFilterSchema = (): Observable<any> => {
	const url = URLConfig.getFieldRepFilterSchemaURL();
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			console.log("Field Rep Filter Schema fetched successfully:", response);
			subscriber.next(response);
			subscriber.complete();
		}, error => {
			console.error("Error fetching Field Rep Filter Schema:", url);
			subscriber.error(error);
		});
	});
}

export const getDashboardOverview = (queryParams: Array<{ key: OdQueryParam; value: string[] }>) => {
	let url = URLConfig.getDashboardOverview();
	if (queryParams && queryParams.length > 0) {
		for (const param of queryParams) {
			url = helperFunctions.addQueryParam(url, param.key, param.value);
		}
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			const res = response as unknown as IDashboardOverviewResponse;
			subscriber.next(res);
			subscriber.complete();
		}, error => {
			subscriber.error(error);
		});
	});
}

export const getLocationRepStatus = (queryParams: Array<{ key: OdQueryParam; value: string[] }>) => {
	let url = URLConfig.getDashboardLocationRepStatus();
	if (queryParams && queryParams.length > 0) {
		for (const param of queryParams) {
			url = helperFunctions.addQueryParam(url, param.key, param.value);
		}
	}
	return new Observable((subscriber) => {
		NetworkService.get(url).then(response => {
			const res = response as unknown as IDashboardLocationResponse;
			subscriber.next(res);
			subscriber.complete();
		}, error => {
			subscriber.error(error);
		});
	});
}
